import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import AppWrapper from "../Common/AppWrapper";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, Link } from "react-router-dom";
import Loading from "../Common/Misc/Loading.jsx";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Popover from "react-bootstrap/Popover";
import ModalAddToCartAndQuote from "../Common/ModalComponents/ModalAddToCartAndQuote.jsx";
import NameModal from "../Common/ModalComponents/NameModal.jsx";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import ReactMarkdown from "react-markdown";
import AssayName from "./AssayName.jsx";
import {
  formatAssayFormat,
  formatAssayApplicationType,
  formatTradeMark,
  processOrderObject,
  formatGenomeOrganism,
  changeFormatForOther,
  mapAppType,
  processOrderingInfo,
  doesNotExist,
  toCamel,
  processExonic,
  cutSiteFormat,
  formatExpectedAmplicons,
  formatUniversalAssayName,
  formatFluorophores,
} from "../../util/format.js";
import * as config from "../../app.config";
import * as assayActions from "../../actions/assays";
import * as cartActions from "../../actions/addToCart";
import * as userActions from "../../actions/user";
import "./AssayDetail.scss";
// Import stub data for the new format.

const instruments = {
  QX100: {
    name: "QX100",
    link: "/en-us/product/qx100-droplet-digital-pcr-system?ID=M9HE3XE8Z",
  },
  QX200: {
    name: "QX200",
    link: "/en-us/product/qx200-droplet-digital-pcr-system",
  },
  QXONE: {
    name: "QXONE",
    link:
      "/en-us/product/qx-one-droplet-digital-pcr-ddpcr-system?ID=PWKDMP511OPG",
  },
};

const quenchers = {
  IowaBlack: "Iowa Black",
  IowaBlack_RQ: "Iowa Black RQ",
  ZenIowaBlack: "ZEN/Iowa Black",
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  nav: {
    backgroundColor: "#fff",
    color: "#000",
    boxShadow: "0 0 0 0 ",
  },
  tab: {
    "&:active": {
      color: "#ff000",
      backgroundColor: "#fff",
    },
  },
});

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    color: "#505050",

    active: {
      backgroundColor: "#fff",
      borderBottom: "none",
      color: "#000000",
    },
    focus: {
      backgroundColor: "#fff",
      borderBottom: "none",
      borderTop: "none",
      color: "#0A963F",
    },
  },
  selected: {
    color: "#0A963F",
    backgroundColor: "#fff",
    borderBottom: "none",
  },
}))((props) => <Tab disableRipple {...props} />);

const handleFocus = (event) => event.target.select();

const TabContainer = (props) => {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
};

const SelectText = (props) => (
  <textarea id="text-area" value={props.value} onFocus={handleFocus} readOnly />
);
//EDIT : Refactor the search URL
const SEARCH_URL =
  "https://www.bio-rad.com/evportal/evolutionPortal.portal?_nfpb=true&_pageLabel=search_page&sfMode=search&searchString=";

const AssayError = (searchTerm) => (
  <div
    id="no-assay-found-outer"
    className="alert alert-danger align-items-center col-11"
    role="alert"
  >
    <div id="no-assay-found" className="alert alert-danger ">
      Sorry, we didn’t recognize your entry. This unique assay ID may no longer
      be available. Please check that the search term is valid and try again, or
      search for{" "}
      <a
        className="search-link"
        href={`${SEARCH_URL}${searchTerm.searchTerm}&database=assays`}
      >
        {searchTerm.searchTerm}
      </a>{" "}
      on bio-rad.com
    </div>
  </div>
);

const AssayPrivacyError = (searchTerm) => (
  <div
    id="no-assay-found-outer"
    className="Zalert Zalert-danger align-items-center col-12"
    role="alert"
  >
    <small>
      <Link to="/digital-assays/assay-design-history">
        <i className="fa fa-angle-double-left" /> Back to My Assays
      </Link>
    </small>

    <div id="no-assay-found" className="alert alert-danger ">
      The ddPCR assay you searched for is marked private and only accessible to
      the user that made the design request. If you require assistance with your
      assay, please contact{" "}
      <a href="https://www.bio-rad.com/en-us/contact-us">Technical Support</a>.
    </div>
  </div>
);

// Assay Detail component for the assays.
class AssayDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      showModal: false,
      assayCommercialId: false,
      isQuote: false,
      cartClicked: false,
      quoteClicked: false,
      showNameModal: false,
    };
    this.handleCartClicked = this.handleCartClicked.bind(this);
    this.handleQuoteClicked = this.handleQuoteClicked.bind(this);
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleAddAssay(e) {
    e.preventDefault();
  }

  handleModalDisplay(e) {
    e.preventDefault();
    this.setState({ showModal: true, isQuote: false });
  }

  handleQuoteModalDisplay(e) {
    e.preventDefault();
    this.setState({ showModal: true, isQuote: true });
  }

  copyText(e) {
    e.preventDefault();
    const textElement = document.getElementById("text-area");
    textElement.select();
    document.execCommand("copy");
  }

  componentWillUnmount() {
    const { actions } = this.props;
    actions.clearAssayDetail();
  }

  componentDidMount() {
    
    const {
      match: {
        params: { assayCommercialId },
      },
      assay: { mine },
      authenticating
    } = this.props;
    
    this.setState({ assayCommercialId: assayCommercialId, mine: mine,});
    if (!authenticating){
      this.handleFetchDetail(assayCommercialId);
    }
   
   
      
    
    

    if (document.location && document.location.hash) {
      setTimeout(function () {
        const element = document.getElementById("vector-backbone-assays");
        element && element.scrollIntoView({ behavior: "smooth" });
      }, 2000);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      match: {
        params: { assayCommercialId },
      },
      assay: { mine },
      authenticating
    } = nextProps;
    if (
      assayCommercialId !== prevState.assayCommercialId ||
      mine !== prevState.mine || authenticating !== nextProps.authenticating
    ) {
      return {isQuote: false,
        cartClicked: false,showNameModal: false,
        quoteClicked: false, assayCommercialId: assayCommercialId, mine: mine};
    } else {
      return null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { assayCommercialId, showModal, mine } = this.state;
    if (
      prevState.assayCommercialId !== assayCommercialId ||
      prevState.mine !== mine || prevProps.authenticating !== this.props.authenticating
    ) {
      this.handleFetchDetail(assayCommercialId);
    }
    const { actions, assay, uniqueUuidId } = this.props;
    const orderingInfo =
      (!_.isEmpty(assay) &&
        !_.isEmpty(assay.data) &&
        !_.isEmpty(assay.data.orderingInfo) &&
        assay.data.orderingInfo) ||
      {};
    if (showModal && !_.isEmpty(orderingInfo)) {
      actions.setAssayModalType(assayActions.ADD_TO_CART_MODAL, uniqueUuidId);
      this.setState({ showModal: false });
    }
  }

  // Actions to fetch data.
  handleFetchDetail(assayCommercialId) {
    const { actions } = this.props;
    actions.fetchAssayDetail(assayCommercialId);
    this.setState({ assayCommercialId });
  }
  handleCartClicked() {
    this.setState({ cartClicked: !this.state.cartClicked });
  }
  handleQuoteClicked() {
    this.setState({ quoteClicked: !this.state.quoteClicked });
  }
  addToMyAssayList(assayCommercialId) {
    const { actions } = this.props;
    actions.addToMyAssay(assayCommercialId);
  }

  handleAddToMyDesigns = (assayCommercialId, canOverrideAssayName) => {
    if (canOverrideAssayName) {
      this.setState({ showNameModal: true });
    } else {
      this.addToMyAssayList(assayCommercialId);
    }
  };

  closeNameModal = () => {
    this.setState({ showNameModal: false });
  };

  render() {
    const processRefSeq = (refSeq) => {
      const refSeqArray = refSeq.split(",");
      return refSeqArray;
    };
    const {
      classes,
      assay,
      actions,
      formObj,
      notFound,
      cartActions,
      cartLink,
      pageLoading,
      privacyError,
      uniqueUuidId,
      detailMeta,
      digitalAssaysUser,
    } = this.props;

    const assayDetails = assay.data;
    const searchTerm =
      (this.props.match &&
        this.props.match.params &&
        this.props.match.params.assayCommercialId) ||
      "";
    const { value, assayCommercialId, cartClicked, quoteClicked } = this.state;
    const isLoading = _.isEmpty(assay) && !notFound;
    const haveError = notFound && !assayDetails;
    const baseURL = config.ENDPOINTS.assets;

    if (pageLoading) {
      return (
        <AppWrapper id="assay-detail">
          <Loading isLoading={pageLoading} />
        </AppWrapper>
      );
    }

    const AddToCartButton = ({ cartLink }) => (
      <div className="add-to-cart">
        {!cartClicked && (
          <button
            id="btn-add-to-cart"
            type="button"
            className="outline rounded large float-right"
            onClick={(e) => {
              this.handleModalDisplay(e);
            }}
          >
            Add to Cart
          </button>
        )}
        {cartClicked && (
          <div>
            <a className="check-cart" href={cartLink}>
              <button
                id="btn-add-to-cart"
                className="outline rounded large float-right"
                type="button"
              >
                Check Out
              </button>
            </a>
          </div>
        )}
        {quoteClicked && (
          <div className="quote-options">
            <a className="check-quote" href={`${cartLink}#fragment-2`}>
              Get Quote
            </a>
          </div>
        )}
        {!quoteClicked && (
          <div className="quote-options">
            <a
              href="#"
              onClick={(e) => {
                this.handleQuoteModalDisplay(e);
              }}
            >
              Add to Quote
            </a>
          </div>
        )}
      </div>
    );

    const AddToMyAssaysButton = ({
      assayCommercialId,
      canOverrideAssayName,
    }) => (
      <div className="add-to-my-assays">
        <button
          id="add-assay-btn"
          type="button"
          className="rounded outline"
          onClick={(e) => {
            e.preventDefault();
            this.handleAddToMyDesigns(assayCommercialId, canOverrideAssayName);
          }}
        >
          Add to My Designs
        </button>
      </div>
    );

    if (privacyError) {
      return (
        <AppWrapper id="assay-detail">
          <div className="container main-content">
            <AssayPrivacyError searchTerm={searchTerm} />
          </div>
        </AppWrapper>
      );
    }
    if (isLoading) {
      return (
        <AppWrapper id="assay-detail">
          <Loading isLoading={isLoading} />
        </AppWrapper>
      );
    }

    if (haveError) {
      return (
        <AppWrapper id="assay-detail">
          <AssayError searchTerm={searchTerm} />
        </AppWrapper>
      );
    }

    const REFERENCE_SEQUENCE_URL = "https://www.ncbi.nlm.nih.gov/nuccore/";
    const ENSEMBLE_ID_URL = "http://www.ensembl.org/id/";
    const UNIGENE_ID_URL =
      "http://www.ncbi.nlm.nih.gov/UniGene/clust.cgi?ORG=Hs&CID=";
    const ENTREZ_PREFEX_URL =
      "http://www.ncbi.nlm.nih.gov/sites/entrez?db=gene&term=";
    const {
      name,
      positiveControls,
      chemistry,
      assayOfOrigin,
      compatibleInstruments,
      compatibleRestrictionEnzymes,
      documentation,
      dyes,
      id,
      exonic,
      expectedAmplicons,
      mine,
      miqeContexts,
      myDesign,
      orderingInfo,
      predictedAmplicon,
      companionAssays,
      primerPurification,
      probePurification,
      props,
      quencher,
      recommendedRestrictionEnzyme,
      referenceAssays,
      target,
      userOptions,
      validation,
      description,
      universalAssays,
    } = assayDetails || {};

    const { orderingUrl, sequence } = positiveControls || {};
    const { assayName, uniqueAssayId } = orderingInfo;
    const newOrderingInfo = orderingInfo;
    const {
      gene,
      genome,
      targetType,
      donorSequence,
      editRegionDonorRange,
    } = target;
    const {
      aliasSymbols,
      ensemblId,
      entrezId,
      officialSymbol,
      refSeqAccessions,
      symbol,
    } = gene || {};
    const {
      assaySpecificity,
      experimentalSample,
      images,
      instrument,
      reportUrl,
      supermix,
      type,
    } = validation || {};
    const { assayDetailsView, canOverrideAssayName } = userOptions || {};
    const editableUserName = (props && props.assayName) || "";

    const { chromosomalLocation, geneDescription, geneEntrez } = gene || {};

    // Couldn't find it in new assay format.
    const applicationType =
      assayDetails && mapAppType(assayDetails.applicationType);
    const assayFormat =
      assayDetails &&
      assayDetails.assayFormat &&
      formatAssayFormat(assayDetails.assayFormat);
    const userAmplicons =
      (target.targetType === "HdrGenomeEdit" &&
        assayDetailsView &&
        assayDetailsView.expectedAmplicons) ||
      [];
    const uneditedAmplicon =
      (target.targetType === "HdrGenomeEdit" &&
        formatExpectedAmplicons(
          _.findWhere(userAmplicons, { name: "Native" })
        )) ||
      [];
    const editedAmplicon =
      (target.targetType === "HdrGenomeEdit" &&
        formatExpectedAmplicons(
          _.findWhere(userAmplicons, { name: "HdrEdited" })
        )) ||
      [];
    const processedOrderingInfo =
      (!_.isEmpty(newOrderingInfo) && {
        ...orderingInfo,
        skuMap: processOrderObject(newOrderingInfo.skuMap),
        targetType: target.targetType || false,
      }) ||
      {};

    const miqeFormatted = (organism, miqeContext) => {
      var output = miqeContext.location;
      if (
        organism &&
        organism !== "null" &&
        organism !== null &&
        organism.toLowerCase() === "none"
      ) {
        output = miqeContext.location.split("|")[1];
      }
      return output;
    };

    const formatDescription = (description) => {
      return description.replace(
        /\/digital-assays/gi,
        `${baseURL}/digital-assays`
      );
    };

    return (
      <AppWrapper
        id="assay-detail"
        pageTitle={(detailMeta && detailMeta.title) || ""}
        pageDescription={(detailMeta && detailMeta.description) || ""}
        pageKeywords={(detailMeta && detailMeta.keywords) || ""}
      >
        <div>
          <div id="bg">
            <div id="bg-inner"></div>
          </div>

          <div className="container main-content">
            <div className="hero-space">
              <div className="row">
                <div className="col-6">
                  <h1>Assay Details</h1>
                  {/*
                    <small>
                      <Link to="/digital-assays/assay-design-history">
                        <i className="fa fa-angle-double-left" /> Back to My Assays
                      </Link>
                    </small>

                    */}
                </div>
                <div className="col-6 text-right">
                  {/*Add to Cart Button || Add to MyAssays<*/}
                  {mine && assayDetails && (
                    <span>
                      <AddToCartButton cartLink={cartLink} />
                      <br />
                    </span>
                  )}

                  <ModalAddToCartAndQuote
                    orderingInfo={processedOrderingInfo}
                    actions={actions}
                    cartActions={cartActions}
                    uniqueRowId={uniqueUuidId}
                    isQuote={this.state.isQuote}
                    handleCartClicked={this.handleCartClicked}
                    handleQuoteClicked={this.handleQuoteClicked}
                  />

                  {!mine && assayDetails && (
                    <AddToMyAssaysButton
                      assayCommercialId={id}
                      canOverrideAssayName={canOverrideAssayName || false}
                    />
                  )}
                </div>
              </div>
            </div>

            <Paper elevation={5} square={false}>
              <div id="assay-detail-header" className={classes && classes.root}>
                <div className="row">
                  {assayDetails && (
                    <div className="col-12">
                      <h3>{(detailMeta && detailMeta.title) || ""}</h3>
                    </div>
                  )}

                  {this.state.showNameModal && canOverrideAssayName && (
                    <NameModal
                      assayCommercialId={id}
                      openModal={this.state.showNameModal}
                      assayName={props.assayName}
                      closeModal={this.closeNameModal}
                    />
                  )}
                </div>
              </div>
              <div id="assay-detail-body" className={classes && classes.root}>
                <AppBar position="static" className={classes.nav}>
                  <Tabs
                    TabIndicatorProps={{
                      style: {
                        height: 0,
                      },
                    }}
                    onChange={this.handleChange}
                    value={value || 0}
                  >
                    {!_.isEmpty(assayDetails) && (
                      <AntTab className="tab" value={0} label="Details" />
                    )}

                    {!_.isEmpty(images) && (
                      <AntTab className="tab" value={1} label="Validation" />
                    )}

                    {!_.isEmpty(positiveControls) && (
                      <AntTab
                        className="tab"
                        value={2}
                        label="Positive Control"
                      />
                    )}

                    {!_.isEmpty(documentation) && (
                      <AntTab className="tab" value={3} label="Documents" />
                    )}
                  </Tabs>
                </AppBar>
                {/**************************************** TAB 1 START ****************************************/}

                {value === 0 && assayDetails && (
                  <TabContainer>
                    <div className="single-tab">
                      {/*Application Type*/}
                      {applicationType && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Application Type:
                              </div>
                            </div>
                            <div className="col-8">
                              {applicationType}{" "}
                              {applicationType === "Mutation Detection" &&
                                assayFormat}
                              {targetType === "NhejGenomeEdit" && (
                                <span>{": Nhej"}</span>
                              )}
                              {targetType === "HdrGenomeEdit" && (
                                <span>{": HDR"}</span>
                              )}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Application Name*/}
                      {
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Assay Name:
                                <OverlayTrigger
                                  trigger="hover"
                                  placement="auto"
                                  overlay={
                                    <Popover title="Assay Name">
                                      The Assay Name is based on the commonly
                                      used identifier for the assay&#39;s
                                      target, such as the Gene Symbol or amino
                                      acid change. Examples:
                                      <ul>
                                        <li>
                                          {" "}
                                          Copy Number Assay:{" "}
                                          <span className="italic-font">
                                            EGFR
                                          </span>
                                        </li>
                                        <li>
                                          {" "}
                                          Mutation Assay:{" "}
                                          <span className="italic-font">
                                            PIK3CA
                                          </span>
                                          <span>p.G1049C</span>
                                        </li>
                                      </ul>
                                      If you enter a target as a sequence and
                                      the sequence exactly matches a known
                                      target, the assay name will be derived
                                      from the Target Name you provided and can
                                      be changed by you at any time by clicking
                                      the edit icon next to the Assay Name in
                                      Assay Details.
                                    </Popover>
                                  }
                                >
                                  <i className="far fa-question-circle helper-icon" />
                                </OverlayTrigger>
                              </div>
                            </div>

                            <AssayName
                              name={name}
                              canOverrideAssayName={canOverrideAssayName}
                              actions={actions}
                              assayCommercialId={id}
                              uniqueUuidId={uniqueUuidId}
                              editableUserName={editableUserName}
                            />
                          </div>
                          <br />
                        </div>
                      }
                      {/*Assay Commercial ID*/}
                      {id && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Assay ID:</div>
                            </div>
                            <div className="col-8">{id}</div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*validation.type == "WetLab"*/}
                      <div>
                        <div className="row">
                          <div className="col-4">
                            <div className="assay-label">
                              Wet-Lab Validated:
                            </div>
                          </div>
                          <div className="col-8">
                            <span>
                              {validation.type === "WetLab" ? "Yes" : "No"}
                            </span>
                          </div>
                        </div>
                        <br />
                      </div>
                      {/*Chemistry*/}
                      {chemistry && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Chemistry:</div>
                            </div>
                            <div className="col-8">{chemistry}</div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Quencher*/}
                      {quencher && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Quencher:</div>
                            </div>
                            <div className="col-8">{quenchers[quencher]}</div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Compatible Instruments*/}
                      {compatibleInstruments && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Compatible Instruments:
                              </div>
                            </div>
                            <div className="col-8">
                              {compatibleInstruments &&
                                compatibleInstruments.map(
                                  (instrument, index) => {
                                    return (
                                      <span key={index}>
                                        <a
                                          href={
                                            instruments[
                                              instrument.replace("_", "")
                                            ].link
                                          }
                                          title={instrument}
                                        >
                                          {
                                            instruments[
                                              instrument.replace("_", "")
                                            ].name
                                          }
                                        </a>
                                        {compatibleInstruments.length !==
                                          index + 1 && ", "}
                                      </span>
                                    );
                                  }
                                )}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Dyes*/}
                      {dyes && !_.isEmpty(dyes) && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Probe Fluorophore:
                              </div>
                            </div>
                            <div className="col-8">
                              {dyes && (
                                <span>
                                  {formatFluorophores(
                                    dyes.join("/").toUpperCase()
                                  )}
                                </span>
                              )}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Probe Purification*/}
                      {probePurification && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Probe Purification:
                              </div>
                            </div>
                            <div className="col-8">{probePurification}</div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Primer Purification*/}
                      {primerPurification && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Primer Purification:
                              </div>
                            </div>
                            <div className="col-8">{primerPurification}</div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Target Genome*/}
                      {target &&
                        !_.isEmpty(target) &&
                        !_.isEmpty(target.genome) &&
                        target.genome.organism !== "" &&
                        target.genome.organism !== null &&
                        target.genome.organism !== "null" && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">Genome:</div>
                              </div>
                              <div className="col-8">
                                {target &&
                                  target.genome &&
                                  target.genome.organism && (
                                    <span className="italic-font">
                                      {changeFormatForOther(
                                        formatGenomeOrganism(
                                          target.genome.organism
                                        )
                                      )}
                                    </span>
                                  )}{" "}
                                {target.genome.organism.toLowerCase() !==
                                  "none" && <span>{target.genome.build}</span>}
                              </div>
                            </div>
                            <br />
                          </div>
                        )}
                      {/*Miqe Context*/}
                      {miqeContexts && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                MIQE Context:{" "}
                                <OverlayTrigger
                                  trigger="hover"
                                  placement="auto"
                                  overlay={
                                    <Popover title="MIQE Context">
                                      Sequence and coordinates from the
                                      reference genome around your assay&#39;s
                                      amplicon.
                                    </Popover>
                                  }
                                >
                                  <i className="far fa-question-circle helper-icon" />
                                </OverlayTrigger>
                              </div>
                            </div>
                            <div className="col-8 break-word">
                              {miqeContexts &&
                                miqeContexts.map((miqeContext) => {
                                  return (
                                    <div key={miqeContext.location}>
                                      <div>
                                        {miqeFormatted(
                                          target.genome.organism,
                                          miqeContext
                                        )}
                                      </div>
                                      <div>{miqeContext.sequence}</div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Amplicon Length*/}
                      {(predictedAmplicon || expectedAmplicons) && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Amplicon Length:
                              </div>
                            </div>
                            <div className="col-8">
                              {assayDetails.applicationType !==
                                "GeneExpression" &&
                                !_.isEmpty(predictedAmplicon) &&
                                predictedAmplicon.map((predictedAmplicon) => {
                                  return (
                                    <div key={predictedAmplicon.length}>
                                      <div>{predictedAmplicon.length}</div>
                                    </div>
                                  );
                                })}

                              {assayDetails.applicationType ===
                                "GeneExpression" &&
                                !_.isEmpty(expectedAmplicons) &&
                                expectedAmplicons.map((expectedAmplicon) => {
                                  return (
                                    <div key={expectedAmplicon}>
                                      <div>
                                        {expectedAmplicon.sequence.length}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {predictedAmplicon &&
                        assayDetails.applicationType ===
                          "GenomeEditDetection" &&
                        target.targetType === "NhejGenomeEdit" && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">
                                  Unedited Amplicon Sequence:{" "}
                                  <OverlayTrigger
                                    trigger="hover"
                                    placement="auto"
                                    overlay={
                                      <Popover title="Unedited Amplicon Sequence">
                                        Cut site of the unedited genome targeted
                                        for the genome editing is shown as a ^.
                                      </Popover>
                                    }
                                  >
                                    <i className="far fa-question-circle helper-icon" />
                                  </OverlayTrigger>
                                </div>
                              </div>
                              {predictedAmplicon.map((predictedAmplicon) => {
                                return (
                                  <div
                                    className="col-8"
                                    style={{ wordWrap: "break-word" }}
                                    key={predictedAmplicon}
                                  >
                                    <div>
                                      {cutSiteFormat(
                                        predictedAmplicon.cutSite,
                                        "^",
                                        predictedAmplicon.sequence
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                            <br />
                          </div>
                        )}
                      {!_.isEmpty(assayDetailsView) &&
                        !_.isEmpty(userAmplicons) &&
                        assayDetails.applicationType ===
                          "GenomeEditDetection" &&
                        target.targetType === "HdrGenomeEdit" && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">
                                  Unedited Amplicon Sequence:{" "}
                                  <OverlayTrigger
                                    trigger="hover"
                                    placement="auto"
                                    overlay={
                                      <Popover title="Unedited Amplicon Sequence">
                                        Sequence of the unedited genome targeted
                                        for genome editing is shown within curly
                                        braces in bold
                                      </Popover>
                                    }
                                  >
                                    <i className="far fa-question-circle helper-icon" />
                                  </OverlayTrigger>
                                </div>
                              </div>

                              <div
                                className="col-8"
                                style={{ wordWrap: "break-word" }}
                              >
                                <span>{uneditedAmplicon.left}</span>
                                <span>
                                  <b>{uneditedAmplicon.middle}</b>
                                </span>
                                <span>{uneditedAmplicon.right}</span>
                              </div>
                            </div>
                            <br />
                          </div>
                        )}
                      {!_.isEmpty(assayDetailsView) &&
                        !_.isEmpty(userAmplicons) &&
                        assayDetails.applicationType ===
                          "GenomeEditDetection" &&
                        target.targetType === "HdrGenomeEdit" && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">
                                  Edited Amplicon Sequence:{" "}
                                  <OverlayTrigger
                                    trigger="hover"
                                    placement="auto"
                                    overlay={
                                      <Popover title="Edited Amplicon Sequence">
                                        Sequence of the edited genome targeted
                                        for genome editing is shown within curly
                                        braces in bold
                                      </Popover>
                                    }
                                  >
                                    <i className="far fa-question-circle helper-icon" />
                                  </OverlayTrigger>
                                </div>
                              </div>

                              <div
                                className="col-8"
                                style={{ wordWrap: "break-word" }}
                              >
                                <span>{editedAmplicon.left}</span>
                                <span>
                                  <b>{editedAmplicon.middle}</b>
                                </span>
                                <span>{editedAmplicon.right}</span>
                              </div>
                            </div>
                            <br />
                          </div>
                        )}
                      {donorSequence &&
                        assayDetails.applicationType ===
                          "GenomeEditDetection" &&
                        target.targetType !== "HdrGenomeEdit" && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">
                                  Donor Sequence:
                                </div>
                              </div>
                              <div
                                className="col-8"
                                style={{ wordWrap: "break-word" }}
                              >
                                {donorSequence}
                              </div>
                            </div>
                            <br />
                          </div>
                        )}
                      {donorSequence &&
                        assayDetails.applicationType ===
                          "GenomeEditDetection" &&
                        target.targetType === "HdrGenomeEdit" && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">
                                  Donor Sequence:
                                </div>
                              </div>
                              <div
                                className="col-8"
                                style={{ wordWrap: "break-word" }}
                              >
                                <span>
                                  {donorSequence.slice(
                                    0,
                                    editRegionDonorRange.start
                                  )}
                                  {"{"}
                                </span>
                                <span>
                                  <b>
                                    {donorSequence.slice(
                                      editRegionDonorRange.start,
                                      editRegionDonorRange.end
                                    )}
                                  </b>
                                </span>
                                <span>
                                  {"}"}
                                  {donorSequence.slice(
                                    editRegionDonorRange.end
                                  )}
                                </span>
                              </div>
                            </div>
                            <br />
                          </div>
                        )}
                      {/*companion assays*/}
                      {companionAssays && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Companion Assay:
                              </div>
                            </div>
                            <div className="col-8">
                              {companionAssays.map((companionAssay) => {
                                return (
                                  <div key={companionAssay.identifier}>
                                    <div>
                                      <Link
                                        to={`/digital-assays/assay-detail/${companionAssay.identifier}`}
                                      >
                                        {companionAssay.name}
                                      </Link>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Reference Assays*/} {/*Can be an array*/}
                      {referenceAssays && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Recommended Reference Assays:
                                <OverlayTrigger
                                  trigger="hover"
                                  placement="auto"
                                  overlay={
                                    <Popover title="Recommended Reference Assays">
                                      Assays recommended for use as a reference
                                      with your assay with your complementary
                                      dye.
                                    </Popover>
                                  }
                                >
                                  <i className="far fa-question-circle helper-icon" />
                                </OverlayTrigger>
                              </div>
                            </div>
                            <div className="col-8">
                              {_.map(referenceAssays, (value, index) => {
                                if (index == referenceAssays.length - 1) {
                                  return (
                                    <Link
                                      key={index}
                                      to={`/digital-assays/assay-detail/${value.identifier}`}
                                    >
                                      {`${value.geneSymbol}(${value.identifier}) `}
                                    </Link>
                                  );
                                } else {
                                  return (
                                    <Link
                                      key={index}
                                      to={`/digital-assays/assay-detail/${value.identifier}`}
                                    >
                                      {`${value.geneSymbol}(${value.identifier}) `}{" "}
                                      {", "}
                                    </Link>
                                  );
                                }
                              })}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Recommended Restriction Enzyme*/}
                      {recommendedRestrictionEnzyme && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Recommended Restriction Enzyme:
                              </div>
                            </div>
                            <div className="col-8">
                              {recommendedRestrictionEnzyme}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Compatible Restriction Enzyme*/}
                      {compatibleRestrictionEnzymes &&
                        !_.isEmpty(compatibleRestrictionEnzymes) && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">
                                  Compatible Restriction Enzymes:
                                </div>
                              </div>
                              <div className="col-8">
                                {compatibleRestrictionEnzymes && (
                                  <span>
                                    {compatibleRestrictionEnzymes.join(", ")}
                                  </span>
                                )}
                              </div>
                            </div>
                            <br />
                          </div>
                        )}
                      {/*Target Cosmic ID*/}
                      {target && target.cosmicId && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">COSMIC ID:</div>
                            </div>
                            <div className="col-8">{target.cosmicId}</div>
                          </div>{" "}
                          <br />
                        </div>
                      )}
                      {target && target.wildTypeAllele && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                WildType Allele:
                              </div>
                            </div>
                            <div className="col-8">
                              {target.wildTypeAllele.map((wildTypeAllele) => {
                                return (
                                  <div key={wildTypeAllele}>
                                    <div>{wildTypeAllele}</div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {target && target.mutantAllele && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Mutant Allele:</div>
                            </div>
                            <div className="col-8">
                              {target.mutantAllele.map((mutantAllele) => {
                                return (
                                  <div key={mutantAllele}>
                                    <div>{mutantAllele}</div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {target && target.mutationStrand && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Mutation Strand:
                              </div>
                            </div>
                            <div className="col-8">{target.mutationStrand}</div>
                          </div>
                          <br />
                        </div>
                      )}
                      {target && target.aminoAcidChange && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Amino Acid Change:
                              </div>
                            </div>
                            <div className="col-8">
                              {target.aminoAcidChange}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {target && target.nucleotideMutation && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Nucleotide Mutation:
                              </div>
                            </div>
                            <div className="col-8">
                              {target.nucleotideMutation}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {target && target.mutationDescription && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Mutation Description:
                              </div>
                            </div>
                            <div className="col-8">
                              {target.mutationDescription}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Gene Details - only for GEX */}
                      {geneDescription &&
                        assayDetails.applicationType === "GeneExpression" && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">Gene Details:</div>
                              </div>
                              <div className="col-8">{geneDescription}</div>
                            </div>
                            <br />
                          </div>
                        )}
                      {/*Gene Symbol*/}
                      {target && target.gene && target.gene.symbol && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Gene Symbol:</div>
                            </div>
                            <div className="col-8">
                              <span className="italic-font">
                                {target.gene.symbol}
                              </span>
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Gene Name - italic*/}
                      {target && target.gene && target.gene.name && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Gene Name:</div>
                            </div>
                            <div className="col-8">
                              <span className="italic-font">
                                {target.gene.name}
                              </span>
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Gene Aliases - italic*/}
                      {aliasSymbols && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Gene Aliases:</div>
                            </div>
                            <div className="col-8">
                              <span className="italic-font">
                                {aliasSymbols.join(", ")}
                              </span>
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {target && target.gene && target.gene.refSeqAccessions && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                RefSeq Accessions:
                              </div>
                            </div>
                            <div className="col-8">
                              {target.gene.refSeqAccessions.join(", ")}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Ensemble ID*/}
                      {ensemblId && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Ensembl Gene ID:
                              </div>
                            </div>
                            <div className="col-8">
                              <a href={`${ENSEMBLE_ID_URL}${ensemblId}`}>
                                {ensemblId}
                              </a>
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Entrez Gene ID*/}
                      {target && target.gene && target.gene.entrezId && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Entrez Gene ID:</div>
                            </div>
                            <div className="col-8">
                              <a
                                href={`${ENTREZ_PREFEX_URL}${target.gene.entrezId}`}
                              >
                                {target.gene.entrezId}
                              </a>
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Exonic*/}
                      {exonic && exonic !== "" && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Intron spanning:
                              </div>
                            </div>
                            <div className="col-8">{processExonic(exonic)}</div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/*Chromosomal Location*/}
                      {chromosomalLocation && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Chromosomal Location:
                              </div>
                            </div>
                            <div className="col-8">{chromosomalLocation}</div>
                          </div>
                          <br />
                        </div>
                      )}
                      {target && target.gene && target.gene.details && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Gene Details:</div>
                            </div>
                            <div className="col-8">
                              {assay.target.gene.details}
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {/* Assay of origin - qPCR Assay Name*/}
                      {assayDetails.applicationType === "GeneExpression" &&
                        assayOfOrigin && (
                          <div>
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">
                                  Corresponding qPCR Assay ID:
                                </div>
                              </div>
                              <div className="col-8">
                                <a
                                  href={`/en-us/SearchResultsPrimePCR?Text=${assayOfOrigin}`}
                                >
                                  {assayOfOrigin}
                                </a>
                              </div>
                            </div>
                            <br />
                          </div>
                        )}
                      {description && (
                        <div>
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">Description:</div>
                            </div>
                            <div className="col-8">
                              <ReactMarkdown
                                source={formatDescription(description)}
                              />
                            </div>
                          </div>
                          <br />
                        </div>
                      )}
                      {universalAssays && !_.isEmpty(universalAssays) && (
                        <div id="vector-backbone-assays">
                          <div className="row">
                            <div className="col-4">
                              <div className="assay-label">
                                Compatible Vector Backbone Assays:
                              </div>
                            </div>
                            <div className="col-8">
                              {universalAssays.map((universalAssay, index) => {
                                return (
                                  <div key={index}>
                                    <Link
                                      to={`/digital-assays/assay-detail/${universalAssay.assayId}`}
                                    >
                                      {universalAssay.assayId &&
                                        formatUniversalAssayName(
                                          universalAssay.assayId
                                        )}{" "}
                                      [
                                      {universalAssay.compatibility &&
                                        universalAssay.compatibility
                                          .compatibleEnzyme &&
                                        universalAssay.compatibility.compatibleEnzyme.join(
                                          ", "
                                        )}
                                      ]
                                    </Link>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <br />
                  </TabContainer>
                )}
                {/**************************************** TAB 1 END    ****************************************/}

                {/**************************************** TAB 2 START Validation Tab ****************************************/}

                {value === 1 && validation && validation.type == "WetLab" && (
                  <TabContainer>
                    <div className="single-tab">
                      {/*Report URL*/}
                      {reportUrl && (
                        <div className="row col-12 ">
                          <div>
                            <a href={`${baseURL}${reportUrl}`} target="_blank">
                              <i className="far fa-file-pdf fa-lg" />
                              &nbsp; Download Validation Data
                            </a>
                          </div>
                        </div>
                      )}
                      <br />
                      {/*ddPCR Instrument*/}
                      {instrument && (
                        <div className="row">
                          <div className="col-4">
                            <div className="assay-label">ddPCR Instrument:</div>
                          </div>
                          <div className="col-8">
                            <a
                              href={
                                instruments[instrument.replace("_", "")].link
                              }
                              target="_blank"
                            >
                              {instruments[instrument.replace("_", "")].name}
                              Droplet Digital&trade; PCR System
                            </a>
                          </div>
                        </div>
                      )}
                      <br />
                      {/*Experiment Samples*/}
                      {experimentalSample && (
                        <div className="row">
                          <div className="col-4">
                            <div className="assay-label">
                              Experiment Samples:
                            </div>
                          </div>
                          <div className="col-8">
                            <span>{experimentalSample.join(", ")}</span>
                          </div>
                        </div>
                      )}
                      <br />

                      {supermix && (
                        <div className="row">
                          <div className="col-4">
                            <div className="assay-label">ddPCR Supermix:</div>
                          </div>
                          <div className="col-8">
                            <a
                              href="/en-us/product/ddpcr-supermix-for-probes-no-dutp?ID=N3D45ZE8Z"
                              target="_blank"
                            >
                              {supermix}
                            </a>
                          </div>
                        </div>
                      )}
                      <br />

                      {images &&
                        !_.isEmpty(images) &&
                        _.map(images, (image, key) => (
                          <div className="row" key={key}>
                            <div className="col-12">
                              <div className="assay-label">{image.title}</div>
                            </div>
                            <div className="col-12">
                              <p>{image.caption}</p>
                            </div>
                            <div className="col-12">
                              <img
                                className="image-holder"
                                src={`${baseURL}${image.url}`}
                              />
                            </div>
                          </div>
                        ))}
                    </div>
                  </TabContainer>
                )}
                {/**************************************** TAB 2 END    ****************************************/}

                {/**************************************** TAB 3 START  ****************************************/}
                {value === 2 && positiveControls && (
                  <TabContainer>
                    <div className="single-tab">
                      {/*Experiment Samples*/}
                      {positiveControls &&
                        !_.isEmpty(positiveControls) &&
                        positiveControls.map((positiveControl, index) => (
                          <div key={index}>
                            {/* Positive controls type*/}
                            {
                              <div className="row">
                                <div className="col-4">
                                  <div className="assay-label">Type:</div>
                                </div>
                                <div className="col-8">
                                  {toCamel(positiveControl.type)} Gene Fragments
                                </div>
                              </div>
                            }
                            <br />

                            <div className="row col-xs-12 col-sm-12">
                              <p className="no-print">
                                For instructions on preparing the positive
                                controls, please see the assay instruction
                                manual.
                              </p>
                            </div>

                            {/* Sequence copy block*/}
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">Sequence:</div>
                              </div>
                              <div className="col-8">
                                <p>
                                  <a href="" onClick={this.copyText}>
                                    Click Here
                                  </a>{" "}
                                  to select the positive control sequence. Then
                                  to copy it to your clipboard, press Ctrl + C
                                  for Windows users or ⌘ + C for Mac users.
                                </p>
                                {positiveControl && (
                                  <div
                                    className="code-outer"
                                    key={positiveControl.sequence}
                                  >
                                    <code>
                                      <SelectText
                                        value={positiveControl.sequence}
                                      />
                                    </code>
                                  </div>
                                )}
                              </div>
                            </div>
                            <br />
                            <div className="row col-xs-12 col-sm-12">
                              <p className="no-print">
                                Copy the above positive control sequence and go
                                to the link below and paste to order.
                              </p>{" "}
                            </div>

                            {/* Order URL*/}
                            <div className="row">
                              <div className="col-4">
                                <div className="assay-label">
                                  Order from{" "}
                                  <abbr
                                    title="Integrated DNA Technologies"
                                    className="help-cursor"
                                  >
                                    IDT:
                                  </abbr>
                                </div>
                              </div>

                              <div className="col-8">
                                {positiveControl &&
                                  positiveControl.orderingUrl &&
                                  positiveControl.type && (
                                    <div key={positiveControl.orderingUrl}>
                                      <a
                                        href={positiveControl.orderingUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {toCamel(positiveControl.type)} Gene
                                        Fragments
                                      </a>
                                    </div>
                                  )}
                              </div>
                            </div>
                            <br />
                          </div>
                        ))}
                    </div>
                  </TabContainer>
                )}

                {/**************************************** TAB 3 END ****************************************/}
                {/**************************************** TAB 4 START  ****************************************/}
                {value === 3 && documentation && (
                  <TabContainer>
                    <div className="single-tab">
                      <div className="row">
                        <div className="col-2">
                          <strong>Number</strong>
                        </div>
                        <div className="col-8">
                          <strong>Description</strong>
                        </div>
                        <div className="col-2">
                          <strong>Download</strong>
                        </div>
                      </div>
                      <div className="doc-row">
                        <div className="row">
                          <div className="col-2">
                            {documentation &&
                              documentation.map((doc, index) => {
                                return <div key={index}>{doc.number}</div>;
                              })}
                          </div>
                          <div className="col-8">
                            {documentation &&
                              documentation.map((doc) => {
                                return (
                                  <div key={doc.number}>
                                    {formatTradeMark(doc.description)}
                                  </div>
                                );
                              })}
                          </div>
                          <div className="col-2">
                            {documentation &&
                              documentation.map((doc) => {
                                return (
                                  <div key={doc.number}>
                                    <a
                                      href={doc.url}
                                      target="_blank"
                                      title={doc.description}
                                    >
                                      <i className="far fa-file-pdf fa-lg" />
                                    </a>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabContainer>
                )}
                {/**************************************** TAB 4 END ****************************************/}
              </div>
            </Paper>
          </div>
        </div>
      </AppWrapper>
    );
  }
}

const stateToProps = (state) => ({
  notFound:
    (state.assays &&
      state.assays.detail &&
      state.assays.detail.response &&
      state.assays.detail.response.status &&
      state.assays.detail.response.status === 404) ||
    false,
    user:
    (state.user && state.user.evoSession && state.user.evoSession.data) || {},
  authenticating: state.user && state.user.authenticating,
  privacyError:
    (state.assays &&
      state.assays.detail &&
      state.assays.detail.response &&
      state.assays.detail.response.status &&
      state.assays.detail.response.status === 403) ||
    false,
  assay:
    (state.assays && state.assays.detail.data && state.assays.detail.data) ||
    false,
  detailMeta: (state.assays && state.assays.detailMeta) || false,
  pageLoading: (state.assays && state.assays.pageLoading) || false,
  uniqueUuidId:
    (state.assays &&
      !_.isEmpty(state.assays.assayAdded) &&
      state.assays.assayAdded.id) ||
    "",
  uniqueUuidId:
    (state.assays &&
      !_.isEmpty(state.assays.assayAdded) &&
      state.assays.assayAdded.id) ||
    "",
  //cartLink:"https://lsds-int-dev2.br.aws-livesite.io/en-us/shopping-cart"
  cartLink:
    (state &&
      !_.isEmpty(state.addToCart) &&
      !_.isEmpty(state.addToCart.assayCartHtml) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0]) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0].props) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0].props.children) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0].props.children[1]) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0].props.children[1].props) &&
      !_.isEmpty(
        state.addToCart.assayCartHtml[0].props.children[1].props.children
      ) &&
      !_.isEmpty(
        state.addToCart.assayCartHtml[0].props.children[1].props.children[0]
      ) &&
      !_.isEmpty(
        state.addToCart.assayCartHtml[0].props.children[1].props.children[0]
          .props
      ) &&
      state.addToCart.assayCartHtml[0].props.children[1].props.children[0].props
        .href) ||
    "",
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...assayActions, ...cartActions, ...userActions }, dispatch),
});

AssayDetail = withStyles(styles)(AssayDetail);

AssayDetail = withRouter(connect(stateToProps, dispatchToProps)(AssayDetail));

AssayDetail.propTypes = {
  classes: PropTypes.object,
  match: PropTypes.object,
  assay: PropTypes.object,
  actions: PropTypes.object,
  assayCommercialId: PropTypes.string,
  name: PropTypes.string,
  authenticating: PropTypes.bool
};
TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
SelectText.propTypes = {
  value: PropTypes.string,
};

export default AssayDetail;
